import React, { useEffect, useState } from "react";
import useAPI from "../../../services/hooks/useAPI";
import searchAPI from "../../API/searchAPI";
import { useLocation, useNavigate } from "react-router-dom";
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import SearchBar from "../../app/SearchBar/SearchBar";
import { Button, Skeleton } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ViewDownloadsDialog } from "../../dialogs/View-Downloads-Dialog";
import { useAuth } from "../../../hooks/useAuth";
import './style.scss';
import {Helmet} from "react-helmet";
import environment from "../../../environment/environment";
import { getAllWithQuery } from "../../API/microAPI";
import axios from "axios";
import { CacheService } from "../../../common/services/cache.service";
import APIService from "../../../services/api.service";
import { UpdateAssignedTicDialog } from "../../dialogs/Assigned-Tic-Dialog";
import { useRecoilState } from "recoil";
import { parksState } from "../../../atoms/parks";
import { tokenState } from "../../../atoms/token";
import { User } from "../../../models/user";

const AssignedTicNum = () => {
  const { user } = useAuth();
  const [ticNums, setTicNums] = useState([]);
  const [users, setUsers] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [ticData, setTicData] = useState(null);
  const [parks, setParks] = useRecoilState(parksState);
  const [reload, setReload] = useState(false);
  const [token, setToken] = useRecoilState(tokenState);

  useEffect(() => {
    const url = `${environment.npgApiUrl}etic/getusers?currentPage=1&pageSize=2000`;
    const apiService = new APIService<User[]>(axios, new CacheService, url);

    apiService.getAnyAsync().then((res:any) => {
      console.log('ax', res);
      // Check if response has data before processing
      if (res && res.data && Array.isArray(res.data)) {
        // remove comma entries
        const filteredUsers = res.data.filter((user) => user.name !== ',');
        setUsers(filteredUsers);
      } else {
        console.error('Invalid response format for users:', res);
        setUsers([]);
      }
    }).catch((err) => {
      console.error('Failed to fetch users:', err);
      setUsers([]);
    });
  }, []);

  useEffect(() => {
    getTicNums();
    setReload(false);
  }, []);

 
  const getParkName = (parkCode: number) => { 
    let park = parks.find((park) => park.code === parkCode);

    return park?.name;
  }

  const getTicNums = () => { 
    const queryString = `?currentPage=1&pageSize=20000`
    const url = `${environment.npgAPI}etic/getAssignedTicNumbers` + queryString;
    const apiService = new APIService<User[]>(axios, new CacheService, url, token);

    apiService.getAnyAsync().then((res:any) => {
      console.log('ax', res);
      if (res && res.data && Array.isArray(res.data)) {
        let sorted = res.data.sort((a, b) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime());
        setTicNums(sorted);
      } else {
        console.error('Invalid response format for TIC numbers:', res);
        setTicNums([]);
      }
    }).catch((err) => {
      console.error('Failed to fetch TIC numbers:', err);
      setTicNums([]);
    });
  }

  const handleRowBtnClick = (event, rowParams) => {
    console.log('row', rowParams);
    setTicData(rowParams.row);
    setShowDialog(true);
  }

  const handleCloseClick = () => {
    setShowDialog(false);
    setTicData(null);
  }

  const handleSaveClick = (requestor: string, row: any) => {
    console.log('save', requestor);
    row.userId = requestor;

    let obj = {
      title: row.title,
      ticNumber: row.id,
      parkId: row.parkId,
      userId: row.userId,
      domain: 'NPS',
    }
    const url = `${environment.npgAPI}etic/UpdateAssignedTicNumber/${row.id}?action=update`;
    const apiService = new APIService<any>(axios, new CacheService, url, token);

    apiService.add(obj).then((res:any) => {
      console.log('update', res);
      setTicData(null);
      getTicNums();
    });
  
    setShowDialog(false);
    
  }

  const formatDate = (date) => { 
    let d = new Date(date);
    return d.toLocaleDateString();
  }

  const columns: GridColDef[] = [
    { field: 'ticNumber', headerName: 'TIC #', width: 100 },
    { field: 'title', headerName: 'Title', width: 350 },
    { field: 'infoType', headerName: 'Info Type', width: 100 },
    { field: 'name', headerName: 'Park Name', width: 300 },
    { field: 'parkCode', headerName: 'Park Code', width: 100 },
    { field: 'createdDate', headerName: 'Create Date', width: 150 },
    { field: 'pmisNumber', headerName: 'PMIS', width: 100 },
    { field: 'requestor', headerName: 'Change Requestor', width: 150 },
    { field: 'edit', headerName: 'Edit',
    hideSortIcons: true,
    width: 100,
    renderCell: (cellValues) => {
      return (
        <Button
          variant={"contained"} 
          color={"primary"}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            handleRowBtnClick(event, cellValues);
          }}
          // fontawesome icon for edit
          
          startIcon={<FontAwesomeIcon icon={["fas", "edit"]}/>}
        >
          Edit
        </Button>
      );
    }
  },
  ];
 
  return (
    <>
    {/* <h1>User Uploads: {user?.profile?.name}</h1> */}
      <Helmet>
        <meta charSet="utf-8"/>
        <title>Assigned TIC Numbers</title>
      </Helmet>
    <h1 className="center">Assigned TIC Numbers</h1>
  
      {showDialog &&
        <UpdateAssignedTicDialog
          ticData={ticData}
          users={users}
          handleSaveClick={handleSaveClick}
          handleCloseClick={handleCloseClick}
        />
      }

      <div className="search-results tall">
      <h3 className="center">({ticNums.length}) Results</h3>

        <div className="center" style={{ height: 600, width: '100%' }}>
          <DataGrid
            getRowHeight={(params) => 'auto'}
            sx={{ '.MuiDataGrid-columnHeaderTitle': {fontWeight: 'bolder'},
             '.MuiDataGrid-columnHeaderTitleContainer': {borderBottom: 1 },
             '.MuiDataGrid-iconButtonContainer': {visibility: 'visible' },
             '.MuiDataGrid-sortIcon': {opacity: 'inherit !important' }
            }}
            rows={ticNums.map((row, index) => (
              {
                id: row.ticNumber,
                ticNumber: row?.ticNumber, 
                title: row.title, 
                name: getParkName(row.parkCode),
                parkId: row.parkId,
                parkCode: row.parkCode,
                userId: row.userId,
                infoType: row.infoType,
                pmisNumber: row.pmisNumber,
                getParkName: row.parkName,
                createdDate: row.createdDate ? formatDate(row.createdDate) : 'No Date',
                requestor: row.name,
              }
            )) || []}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 25 },
              },
            }}
            pageSizeOptions={[5, 10, 25, 50]}
            
            loading={ticNums.length === 0}
          />
        </div>
      </div>
    </>
  );
}

export default AssignedTicNum;